module.exports = __webpack_public_path__ + "assets/icons/plus.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/plus.png
// module id = ./src/styles/icons/plus.png
// module chunks = 0